import React from 'react';

// god bless http://jxnblk.com/react-icons/

const Shape = {
  HalfTop: props => <HalfShape variant="top" {...props} />,
  HalfBottom: props => <HalfShape variant="bottom" {...props} />,
  HalfRight: props => <HalfShape variant="right" {...props} />,
  HalfLeft: props => <HalfShape variant="left" {...props} />,
  Base: props => <ShapeBase vertices={props.vertices} {...props} />,
  Circle: props => <ShapeBase vertices={40} {...props} />,
  Triangle: props => <ShapeBase vertices={3} {...props} />,
  Square: props => <ShapeBase vertices={4} {...props} />,
  Hexa: props => <ShapeBase vertices={6} {...props} />,
  Penta: props => <ShapeBase vertices={5} {...props} />,
  Hepta: props => <ShapeBase vertices={7} {...props} />,
  Okto: props => <ShapeBase vertices={8} {...props} />,
  Ennea: props => <ShapeBase vertices={9} {...props} />,
};

const ShapeBase = props => {
  let { dummy = false } = props;

  if (props.vertices < 3) {
    throw new Error('We need at least 3 vertices to create a shape');
  }

  if (props.vertices > 40) {
    throw new Error('Too many vertices');
  }

  let size = props.size || 96;
  let fill = props.fill || 'currentColor';
  let c = size / 2;
  var r1 = (1 * size) / 2;
  var angle = 360 / props.vertices;
  var offset = 90;
  var viewBox = [0, 0, size, size].join(' ');

  let draw = function(n) {
    var d = [];
    for (var i = 0; i < n; i++) {
      var a = angle * i - offset;
      var line = [
        i === 0 ? 'M' : 'L',
        num(rx(r1, a, c)),
        num(ry(r1, a, c)),
      ].join(' ');
      d.push(line);
    }
    return d.join(' ');
  };

  let datum = [draw(props.vertices)].join(' ');

  let { cb = () => {} } = props;
  return (
    <div
      style={{
        position: 'relative',
        display: 'inline-flex',
        marginLeft: props.padding ? props.padding : 0,
      }}
      className="col-center align-center"
      onClick={() => cb()}
    >
      <svg
        xmlns="http://www.w3.org/svg/2000"
        viewBox={viewBox}
        width={size}
        height={size}
        fill={fill}
        style={{
          pointerEvents: dummy ? 'none' : 'auto',
          transform: props.transform ? props.transform : null,
          filter: props.filter ? props.filter : 'none',
        }}
      >
        <path d={datum} />
      </svg>
      {props.children && (
        <div
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%,-50%)',
            zIndex: 1,
          }}
        >
          {props.children}
        </div>
      )}
    </div>
  );
};

let rad = function(a) {
  return (Math.PI * a) / 180;
};

let rx = function(r, a, c) {
  return c + r * Math.cos(rad(a));
};

let ry = function(r, a, c) {
  return c + r * Math.sin(rad(a));
};

let num = function(n) {
  return n < 0.0000001 ? 0 : n;
};

export default Shape;

function HalfShape({
  variant,
  size = 96,
  fill = 'currentColor',
  transform = null,
}) {
  let viewBox = [0, 0, size, size].join(' ');
  // start < end will draw a clockwise segment, while start > end a counterclockwise one.
  let datum = '';
  if (variant === 'top') {
    datum = partialCircle(
      50,
      65, // center X and Y
      40, // radius
      radians(360), // start angle
      radians(180), // end angle
    )
      .map(command => command.join(' '))
      .join(' ');
  } else if (variant === 'bottom') {
    datum = partialCircle(
      50,
      35, // center X and Y
      40, // radius
      radians(0), // start angle
      radians(180), // end angle
    )
      .map(command => command.join(' '))
      .join(' ');
  } else {
    datum = partialCircle(
      50,
      35, // center X and Y
      40, // radius
      radians(0), // start angle
      radians(180), // end angle
    )
      .map(command => command.join(' '))
      .join(' ');
  }

  return (
    <div
      style={{
        position: 'relative',
        display: 'inline-flex',
      }}
      className="col-center align-center"
    >
      <svg
        xmlns="http://www.w3.org/svg/2000"
        viewBox={viewBox}
        width={size}
        height={size}
        fill={fill}
        style={{
          transform:
            variant === 'right'
              ? 'rotate(90deg)'
              : variant === 'left'
              ? 'rotate(-90deg)'
              : null,
        }}
      >
        <path d={datum} />
      </svg>
    </div>
  );
}
// from http://stackoverflow.com/a/18473154
const partialCircle = (cx, cy, r, start, end) => {
  const length = end - start;
  if (length === 0) return [];

  const fromX = r * Math.cos(start) + cx;
  const fromY = r * Math.sin(start) + cy;
  const toX = r * Math.cos(end) + cx;
  const toY = r * Math.sin(end) + cy;
  const large = Math.abs(length) <= Math.PI ? '0' : '1';
  const sweep = length < 0 ? '0' : '1';

  return [
    ['M', fromX, fromY],
    ['A', r, r, 0, large, sweep, toX, toY],
  ];
};

function radians(degrees) {
  return (degrees * Math.PI) / 180;
}

function degrees(radians) {
  return (radians * 180) / Math.PI;
}
